<template>
  <div class="location_box">
    <div class="location col-12">
      {{ step1 }}
      <span class="location_arrow"></span>
      <span class="step2">{{ step2 }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LocationLine',
  props: {
    step1: {
      type: String,
      default: ''
    },
    step2: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.location_box {
  padding: 15px 0px;

  .location {
    font-size: 12px;
    vertical-align: middle;

    .location_arrow {
      vertical-align: middle;
      display: inline-block;
      content: '&nbsp;';
      background: {
        image: url('/img/icon/navi_arrow.png');
        repeat: no-repeat;
        position: center center;
      }
      width: 7px;
      height: 10px;
      margin-bottom: 3px;
      padding: 0px 7px;
    }

    .step2 {
      color: #007DEF;
    }
  }
}

</style>
